import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export function FloatingWhatsApp() {
  return <motion.a href="https://wa.me/5491127063704" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0
  }} animate={{
    scale: 1
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20,
    delay: 1
  }} className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-brand-gold rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300" aria-label="Contactar por WhatsApp" data-id="element-332" data-mp="6ejw13yd6i6q">
      <MessageCircle className="w-8 h-8 text-white fill-white" data-id="element-333" data-mp="39uqzb9cvadez" />

      {/* Pulse effect */}
      <div className="absolute inset-0 rounded-full border-2 border-brand-gold animate-ping opacity-75" data-id="element-334" data-mp="39swdlstruh9u"></div>
    </motion.a>;
}